export const administrationAccountsHeadOfficeQualityManagerDetails = {
    template: require('./administration-accounts-head-office-quality-manager-details.html'),
    controller: 'AdministrationAccountsHeadOfficeQualityManagerDetailsController'
};
